import { FC } from 'react'
import classNames from 'classnames'

import css from './Collapsible.styles.scss'
import { Chevron } from 'baby-design/icons'

interface CollapsibleProps {
  title: string
  isCollapsed: boolean
  handleCollapse: () => void
  contentMaxHeightClassName?: string
}

const Collapsible: FC<CollapsibleProps> = ({
  children,
  contentMaxHeightClassName,
  handleCollapse,
  isCollapsed,
  title,
}) => {
  const maxHeightClassName =
    contentMaxHeightClassName || css['Collapsible__content--defaultMaxHeight']

  return (
    <div
      className={classNames(css.Collapsible, {
        [css['Collapsible--collapsed']]: isCollapsed,
      })}
      onClick={handleCollapse}
    >
      <div className={css.Collapsible__header}>
        <span>{title}</span>
        <Chevron />
      </div>
      <div
        className={classNames(css.Collapsible__content, maxHeightClassName)}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}

export default Collapsible
